// extracted by mini-css-extract-plugin
export default {"root":"LeftSidePanel_root__kIt4+"};